import { render } from "./JobDetail.vue?vue&type=template&id=9b703a3a"
import script from "./JobDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./JobDetail.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Reporting/JobDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9b703a3a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9b703a3a', __exports__)) {
    api.reload('9b703a3a', __exports__)
  }
  
  module.hot.accept("./JobDetail.vue?vue&type=template&id=9b703a3a", () => {
    api.rerender('9b703a3a', render)
  })

}


export default __exports__